var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LayoutRegistration',{scopedSlots:_vm._u([{key:"main",fn:function(){return [_c('h2',{staticClass:"text-3xl my-0"},[_vm._v("500")]),_c('h3',{staticClass:"text-2xl mt-2"},[_vm._v(_vm._s(_vm.$t('regWizPopUp.routes.notAllowed.subheading')))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }